import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MyButton from '../../../../UI/form/MyButton'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import { editWriteOffActItem } from '../../../../../store/writeOffSlice'
import TextFieldMain from '../../../../form/fields/TextFieldMain'
import { editWriteOffActItemPriceAPI } from '../../../../../api/writeOff/writeOffActItemAPI'

const ChangePriceWriteOffActItemForm = ({ writeOffActItemBd, setOpen }) => {

	const dispatch = useDispatch()

    const [data, setData] = useState(
        writeOffActItemBd ? 
            {
                priceOne: writeOffActItemBd.priceOne,
                priceGeneral: writeOffActItemBd.priceGeneral,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editWriteOffActItemPriceAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const changePriceOne = () => {
        const price = data.priceGeneral ? data.priceGeneral.replace(',', '.') : 0
        let priceOne = 0

        if (price && writeOffActItemBd.count) {
            priceOne = (price / writeOffActItemBd.count).toFixed(2)
            // priceOne = (price / supplyBillItemBd.count).toFixed(0)
        }

        setValueForm(setData, 'priceOne', priceOne)
    }

    const changePriceGeneral = () => {
        const price = data.priceOne ? data.priceOne.replace(',', '.') : 0
        let priceGeneral = 0

        if (price && writeOffActItemBd.count) {
            priceGeneral = (price * writeOffActItemBd.count).toFixed(2)
            // priceGeneral = (price * supplyBillItemBd.count).toFixed(0)
        }

        setValueForm(setData, 'priceGeneral', priceGeneral)
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: writeOffActItemBd.id,
            priceOne: data.priceOne,
            priceGeneral: data.priceGeneral,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('priceOne', 'supplyBillItemPriceForm') ?
				<TextFieldMain
					required={formDataProductRequiredField('priceOne', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'priceOne', e)}
					setValueForm={e => {
                        setValueForm(setData, 'priceOne', e)
                        // changePriceGeneral(e)
                    }}
					forciblyValue={data && data.priceOne ? data.priceOne : ''}
                    onBlurMy={e => {
                        // console.log('onBlurMy', e)
                        changePriceGeneral()
                    }}
					label='Ціна за одиницю'
					placeholder='Введіть число'
					validates={{
						isNumber: true
					}}
				/>
			: ''
        }
        {
			formDataProductIsField('priceGeneral', 'supplyBillItemPriceForm') ?
				<TextFieldMain
					required={formDataProductRequiredField('priceGeneral', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'priceGeneral', e)}
					setValueForm={e => {
                        setValueForm(setData, 'priceGeneral', e)
                        // changePriceOne(e)
                    }}
					forciblyValue={data && data.priceGeneral ? data.priceGeneral : ''}
                    onBlurMy={e => {
                        // console.log('onBlurMy', e)
                        changePriceOne()
                    }}
					label='Ціна загальна'
					placeholder='Введіть число'
					validates={{
						isNumber: true
					}}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangePriceWriteOffActItemForm